import 'es5-shim';
import 'es6-shim';

import 'reflect-metadata';
import 'rxjs';
import 'rxjs/Rx';
import 'zone.js/dist/zone';

import '@angular/common';
import '@angular/compiler';
import '@angular/core';
import '@angular/http';
import '@angular/platform-browser';
import '@angular/platform-browser-dynamic';
import '@angular/forms';
import '@angular/router';
require('bootstrap-loader');
require('bootstrap-select');
require('../../node_modules/bootstrap-select/dist/css/bootstrap-select.css');


import {BrowserModule} from '@angular/platform-browser';
import {NgModule, APP_INITIALIZER} from "@angular/core";
import {RouterModule} from '@angular/router';
import {HttpModule} from '@angular/http';
import {FormsModule} from '@angular/forms';
import {DatepickerModule} from 'ng2-bootstrap/datepicker';
import {AgmCoreModule} from 'angular2-google-maps/core';
import {SimpleNotificationsModule, NotificationsService} from 'angular2-notifications';
import {AdsenseModule} from 'ng2-adsense';
import {Angulartics2Module, Angulartics2GoogleAnalytics} from 'angulartics2';

import {RootComponent} from './components/root/root.component';
import {AppComponent} from './components/app/app.component';
import {HomeComponent} from './components/home/home.component';
import {MeasurementsComponent} from './components/measurements/measurements.component';
import {MenuComponent} from './components/menu/menu.component';
import {TopMenuComponent} from './components/topMenu/topMenu.component';
import {MapComponent} from './components/map/map.component';
import {DropdownComponent} from './components/dropdown/dropdown.component';
import {UserComponent} from './components/user/user.component';
import {LoginComponent} from './components/login/login.component';
import {LoaderComponent} from './components/loader/loader.component';
import {MapDetailsComponent} from './components/mapDetails/mapDetails.component';
import {MapDetailsOverlayComponent} from './components/mapDetailsOverlay/mapDetailsOverlay.component';
import {NoDataComponent} from './components/noData/noData.component';
import {AdSenseComponent} from './components/adSense/adSense.component';

import {SatelliteMapDirective} from './directives/satelliteMap/satelliteMap.directive';

import MenuTogglerService from './services/menuToggler.service';
import MeasurementDataProvider from './services/measurementDataProvider.service';
import Broadcaster from './services/broadcaster.service';
import MeasurementsDataProvider from './services/dataProviders/measurementsDataProvider.service';
import AuthDataProvider from './services/dataProviders/authDataProvider.service';
import Filters from './services/filters.service';
import QueryParams from './services/queryParams.service';
import CypherService from './services/cypher.service';
import AuthService from './services/auth.service';
import LoginService from './services/login.service';
import AdBlockService from './services/adBlock.service';

import {OrderBy} from './pipes/orderBy.pipe';
import {FilterGalleryItemsByAlbumID} from './pipes/filterGalleryItemsByAlbumID.pipe';
import {FilterGalleryItemsByTitle} from './pipes/filterGalleryItemsByTitle.pipe';

import routes from './routes/routes';
import {googleMapsApiKey} from "./googleMapsApiKey";

require('../styl/index.styl');

@NgModule({
    imports: [
        HttpModule,
        BrowserModule,
        RouterModule.forRoot(routes),
        DatepickerModule.forRoot(),
        AgmCoreModule.forRoot({
            apiKey: googleMapsApiKey
        }),
        FormsModule,
        SimpleNotificationsModule,
        AdsenseModule.forRoot({
            adClient: 'ca-pub-7839575520735973',
            adSlot: 4599216843
        }),
        Angulartics2Module.forRoot([Angulartics2GoogleAnalytics])
    ],
    declarations: [
        RootComponent,
        AppComponent,
        HomeComponent,
        MeasurementsComponent,
        MenuComponent,
        TopMenuComponent,
        MapComponent,
        DropdownComponent,
        UserComponent,
        LoginComponent,
        SatelliteMapDirective,
        OrderBy,
        FilterGalleryItemsByAlbumID,
        FilterGalleryItemsByTitle,
        LoaderComponent,
        MapDetailsComponent,
        MapDetailsOverlayComponent,
        NoDataComponent,
        AdSenseComponent
    ],
    bootstrap: [RootComponent],
    providers: [
        MenuTogglerService,
        MeasurementDataProvider,
        Broadcaster,
        MeasurementsDataProvider,
        NotificationsService,
        Filters,
        QueryParams,
        AuthDataProvider,
        CypherService,
        AuthService,
        LoginService,
        {
            provide: APP_INITIALIZER,
            useFactory: (authService: AuthService) => authService.isUserActive,
            deps: [AuthService, AuthDataProvider, CypherService],
            multi: true
        },
        AdBlockService
    ]
})
export default class App {
}



// WEBPACK FOOTER //
// ./src/app/app.base.ts